export default __webpack_public_path__ + "static/media/handprint-8-9-page.8ff8272e.png";